<template>
  <div>
    <section class="loading-container" v-if="loading">
      <img :src='require("@/assets/images/ajax-loader.gif")' class="img-fluid bg-img" />
    </section>
    <section class="login-page">
      <div class="container">
        <form v-on:submit="checkForm" method="post">
          <div v-if="errors.length">
            <ul class="validation-error mb-3">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div v-if="globalError">
            <ul class="validation-error mb-3">
              <li>{{ globalError }}</li>
            </ul>
          </div>
          <div class="text-center">
            <img :src="require('@/assets/images/lucky_family_brand_logo.svg')" alt="logo" width="450" />
          </div>
          <div class="login-form mt-5">
            <div class="form-group">
              <input type="text" class="bottom-input" id="user" v-model="user" placeholder="email" name="user"
                @focus="reset_global_error()" autocomplete="off" required />
            </div>
            <div class="form-group">
              <input type="password" class="bottom-input" id="password" v-model="password" placeholder="password"
                @focus="reset_global_error()" autocomplete="off" required />
            </div>
            <div class="form-group d-flex justify-content-center mt-5">
              <input type="submit" class="btn btn-register" value="Log In" />
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>

import { signIn } from "@/utils/auth.js";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      globalError: "getGlobalError",
      resetUsername: 'auth/getResetUsername',
    })
  },
  data() {
    return {
      logintitle: "Login",
      errors: [],
      user: null,
      password: null,
      loading: false
    };
  },
  props: {
    disable_signup: null,
  },
  mounted() {
    this.$store.dispatch("setGlobalError", { value: "" });
    if (this.resetUsername) {
      this.user = this.resetUsername;
    }
  },
  methods: {
    // forgot_password() {
    //   this.$router.push('/forgot_password_init');
    // },
    reset_global_error() {
      this.$store.dispatch("setGlobalError", { value: "" });
    },
    checkForm: async function (e) {
      this.errors = [];
      this.loading = true;
      let usernamefixed = this.user.toLowerCase();
      this.user = usernamefixed.trim();
      try {
        e.preventDefault();
        if (!this.errors.length) {
          this.$store.dispatch('auth/setSigninLog', { type: 'signin_start', 'signinusername': this.user });
          await signIn(this.user.toLowerCase(), this.password, this.$store, 0);
        }
      } catch (error) {
        this.loading = true;
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>
